import { render, staticRenderFns } from "./shippingComponent.vue?vue&type=template&id=d77cc8a4&scoped=true"
import script from "./shippingComponent.vue?vue&type=script&lang=js"
export * from "./shippingComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d77cc8a4",
  null
  
)

export default component.exports